export enum StrategyTypes {
    Unknown = 0,
    Martingale = 1,
    Treasures = 2,
    RSI_2_0 = 3,
    Custom = 4,
    Wizard = 5,
}
